
export function driverInfoReducer(state, action) {
  switch (action.type) {

    case 'FIELD':
      return { ...state, [action.payload.field]: action.payload.value }

    case 'SET_VALUES':
      return { ...state, ...action.payload, hasTyped: true }

    case 'TOGGLE_VALIDATIONS':
      return { ...state, validateInputs: !state.validateInputs };

    case 'SET_CAN_NEXT':
      return { ...state, canNext: action.payload };

    case 'SET_IS_LOADING':
      return { ...state, isLoading: action.payload };

    case 'SET_LOADING':
      return { ...state, loading: action.payload };

    case 'RESET':
      return { ...state, loading: false, canNext: false, validateInputs: false };

    default:
      return state;
  }
}